import React from "react";

interface ListBlackDashProps {
    size?: number;
}

export default function ListBlackDash({ size = 12 }: ListBlackDashProps) {
    return (
    <svg
        width={size}
        height={size}
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ display: "block" }}
    >
        <path
            d="M11 0H1C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1V11C0 11.2652 0.105357 11.5196 0.292893 11.7071C0.48043 11.8946 0.734784 12 1 12H11C11.2652 12 11.5196 11.8946 11.7071 11.7071C11.8946 11.5196 12 11.2652 12 11V1C12 0.734784 11.8946 0.48043 11.7071 0.292893C11.5196 0.105357 11.2652 0 11 0ZM10 9.5H2C1.86739 9.5 1.74021 9.44732 1.64645 9.35355C1.55268 9.25979 1.5 9.13261 1.5 9C1.5 8.86739 1.55268 8.74021 1.64645 8.64645C1.74021 8.55268 1.86739 8.5 2 8.5H10C10.1326 8.5 10.2598 8.55268 10.3536 8.64645C10.4473 8.74021 10.5 8.86739 10.5 9C10.5 9.13261 10.4473 9.25979 10.3536 9.35355C10.2598 9.44732 10.1326 9.5 10 9.5ZM10 6.5H2C1.86739 6.5 1.74021 6.44732 1.64645 6.35355C1.55268 6.25979 1.5 6.13261 1.5 6C1.5 5.86739 1.55268 5.74021 1.64645 5.64645C1.74021 5.55268 1.86739 5.5 2 5.5H10C10.1326 5.5 10.2598 5.55268 10.3536 5.64645C10.4473 5.74021 10.5 5.86739 10.5 6C10.5 6.13261 10.4473 6.25979 10.3536 6.35355C10.2598 6.44732 10.1326 6.5 10 6.5ZM10 3.5H2C1.86739 3.5 1.74021 3.44732 1.64645 3.35355C1.55268 3.25979 1.5 3.13261 1.5 3C1.5 2.86739 1.55268 2.74021 1.64645 2.64645C1.74021 2.55268 1.86739 2.5 2 2.5H10C10.1326 2.5 10.2598 2.55268 10.3536 2.64645C10.4473 2.74021 10.5 2.86739 10.5 3C10.5 3.13261 10.4473 3.25979 10.3536 3.35355C10.2598 3.44732 10.1326 3.5 10 3.5Z"
            fill="#292929"
        />
    </svg>
    );
}